// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__-ag86","buttonTransparent":"button_buttonTransparent__3YTpI","buttonOk":"button_buttonOk__3oDpX","buttonCancel":"button_buttonCancel__1sGKW"};